import { ENDPOINTS, getApiUrl, Requests } from "@/common";
import {
  IDashboardOverview,
  IDashboardStats,
  IRecentActivity,
  IProgressChart,
  IRecommendation,
  ILeaderboardResponse,
  IGameRewardStatus,
  IClaimGameRewardResponse,
  IGameSsoTicketResponse,
} from "@/common/types/dashboard";

export const dashboardService = {
  // Get dashboard overview
  getDashboardOverview: async (): Promise<IDashboardOverview> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_OVERVIEW));
    return response.data;
  },

  // Get dashboard statistics
  getDashboardStats: async (): Promise<IDashboardStats> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_STATS));
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (): Promise<IRecentActivity[]> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_RECENT_ACTIVITIES));
    return response.data;
  },

  // Get progress chart data
  getProgressChart: async (): Promise<IProgressChart> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_PROGRESS_CHART));
    return response.data;
  },

  // Get recommendations
  getRecommendations: async (): Promise<IRecommendation[]> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_RECOMMENDATIONS));
    return response.data;
  },

  // Get streak leaderboard
  getLeaderboard: async (): Promise<ILeaderboardResponse> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_LEADERBOARD));
    return response.data;
  },

  // Get Chrono Town game reward status
  getGameRewardStatus: async (): Promise<IGameRewardStatus> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_GAME_REWARD_STATUS));
    return response.data;
  },

  // Claim daily quest reward into Chrono Town
  claimDailyQuestReward: async (): Promise<IClaimGameRewardResponse> => {
    const response = await Requests.post(getApiUrl(ENDPOINTS.POST_DASHBOARD_CLAIM_GAME_REWARD), {});
    return response.data;
  },

  // Create single-use SSO ticket to seamlessly enter Chrono Town
  createGameSsoTicket: async (): Promise<IGameSsoTicketResponse> => {
    const response = await Requests.post(getApiUrl(ENDPOINTS.POST_GAME_SSO_TICKET), {});
    return response.data;
  },
};
